export const POWERLINE_UNAVAILABLE = 'Powerline check unavailable. Confirm nearby transmission lines with the local electricity network before relying on this result.';

export function powerlineStatus(data) {
  const status = String(data?.status || '').trim().toLowerCase();
  const failed = Boolean(data?.error) || ['error', 'unknown', 'unavailable'].includes(status)
    || String(data?.impact || '').toUpperCase() === 'UNKNOWN'
    || ['message', 'details', 'note', 'data_source'].some(key => /error|timeout|timed out|unavailable|not available|not installed|undetermined|failed|no valid.*geometry/i.test(String(data?.[key] || '')));
  if (!data || failed) return 'Unknown';
  if (['warning', 'detected'].includes(status) || data.detected === true) return 'Detected';
  if (['safe', 'not detected'].includes(status) || (!status && data.detected === false)) return 'Not Detected';
  return 'Unknown';
}

export function formatPowerlineResult(data) {
  const status = powerlineStatus(data);
  if (status === 'Unknown') return { status, distance: 'N/A', details: POWERLINE_UNAVAILABLE };
  return {
    ...data, status,
    distance: Number.isFinite(data.distance_meters) ? `${Math.round(data.distance_meters)}m` : 'N/A',
    details: data.message || data.details || (status === 'Detected' ? 'A nearby transmission line was detected.' : 'No transmission lines detected within 200m.'),
  };
}
